/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%}table[_ngcontent-%COMP%]   .mat-column-actions[_ngcontent-%COMP%]{width:28%!important}table[_ngcontent-%COMP%]   .mat-cell-description[_ngcontent-%COMP%]{width:25%!important}.mat-cell[_ngcontent-%COMP%]:first-child, .mat-cell[_ngcontent-%COMP%]:first-child   .mat-form-field[_ngcontent-%COMP%], .mat-header-cell[_ngcontent-%COMP%]:first-child, .mat-header-cell[_ngcontent-%COMP%]:first-child   .mat-form-field[_ngcontent-%COMP%]{flex:20%}.mat-card-actions[_ngcontent-%COMP%]{margin-left:1%}"];
export { styles as styles };
